export const S3_PUBLIC_BUCKET_URL = "https://storage.googleapis.com/flip-prod-dbs-assets";
export const BLOG_URL = "https://help.flip.id/article";

// General
export const SUPPORTED_BANK_URL = "https://docs.flip.id/docs/money-transfer/destination-bank";
export const FLIP_ID_URL = "https://flip.id";
export const FLIP_FOR_BUSINESS_URL = "https://business.flip.id/";
export const MAIL_TO_URL = "mailto:support@flip.id";
export const FLIP_API_DOCS = "https://docs.flip.id/";
export const WA_B2BS_CONTACT = "https://wa.me/6281387606852";
export const BIG_FLIP_HELP_CENTER = "https://help.flip.id/category/11";
export const FLIP_PLAY_STORE = "https://play.google.com/store/apps/details?id=id.flip&hl=en&gl=US";
export const FLIP_APP_STORE = "https://apps.apple.com/US/app/id1439301290?mt=8";
export const INTERNATIONAL_TRANSFER = "https://docs.flip.id/#international-transfer";
export const SNAPBI_DOCS = "https://www.bi.go.id/id/layanan/Standar/SNAP/default.aspx";
export const TYPEFORM_AUTO_WITHDRAWAL_CONSENT = "http://flip-id.typeform.com";
export const AUTO_WITHDRAWAL_HC_ARTICLE = "https://help.flip.id/article/24612502967961";

// Login
export const FORGET_PASSWORD_URL = "https://flip.id/lupa-password";

// Beneficiary List
export const BENEFICIARY_TEMPLATE_CSV_URL = `${S3_PUBLIC_BUCKET_URL}/templates/template_recipients_list.csv`;
export const BENEFICIARY_TEMPLATE_EXCEL_URL = `${S3_PUBLIC_BUCKET_URL}/templates/template_recipients_list.xlsx`;
export const BENEFICIARY_TUTORIAL_URL = `${BLOG_URL}/360021495032-Tutorial-Transfer-CSV-Format-Daftar-Penerima`;

// Transaction
export const TEMPLATE_CSV_URL = `${S3_PUBLIC_BUCKET_URL}/templates/big_flip_template_csv.csv`;
export const TEMPLATE_EXCEL_URL = `${S3_PUBLIC_BUCKET_URL}/templates/big_flip_template_xls.xlsx`;
export const TEMPLATE_EXCEL_FLIP_GLOBE_URL = `${S3_PUBLIC_BUCKET_URL}/templates/template_ffb_international_transfer_231023.xlsx`;
export const TEMPLATE_CSV_BENEFICIARY = `${S3_PUBLIC_BUCKET_URL}/templates/template_csv_recipients_format.csv`;
export const TEMPLATE_EXCEL_BENEFICIARY = `${S3_PUBLIC_BUCKET_URL}/templates/template_xls_recipients_format.xlsx`;
export const TEMPLATE_CSV_ID_URL = `${S3_PUBLIC_BUCKET_URL}/templates/big_flip_template_csv_with_unique_id.csv`;
export const TUTORIAL_BENEFICIARY = `${BLOG_URL}/360021495032-Tutorial-Transfer-CSV-Format-Daftar-Penerima`;
export const SUPPORT_DOC_URL = "https://blog.flip.id/fitur-baru-big-flip-id-unik-transaksi-untuk-meningikatkan-keamanan-transaksimu/";
export const SENDING_SLA_ID = `${BLOG_URL}/900003084266-Waktu-Cut-off-Bank`;
export const SENDING_SLA_EN = `${BLOG_URL}/900002971003-Bank-Cut-off-Time`;
export const FORM_ONE_TIME_REQUEST = `${FLIP_ID_URL}/first-verification`;
export const FORM_EXCEEDED_LIMIT = `${FLIP_ID_URL}/edd-international`;

// Verification
export const BI_VERIF_POLICY_URL = "https://flip.id/files/APU%20PPT%20non%20Bank.pdf";
export const TUTORIAL_MULTI_INPUT = `${BLOG_URL}/360021860111-Tutorial-Transfer-Multi-Input`;
export const TUTORIAL_UPLOAD_CSV = `${BLOG_URL}/360021637292-Tutorial-Transfer-Upload-CSV`;
export const TUTORIAL_BENEFICIARY_LIST = `${BLOG_URL}/360021495032-Tutorial-Transfer-CSV-Format-Daftar-Penerima`;
export const TERMS_AND_CONDITIONS = "https://flip.id/syarat-ketentuan";
export const PROHIBITED_ACTIVITIES_ID = `${BLOG_URL}/4405422396057`;
export const PROHIBITED_ACTIVITIES_EN = `${BLOG_URL}/4405429991577-Prohibited-Activities-or-Transactions-at-Big-Flip`;

// API setting
export const GOOGLE_STORE = "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en";
export const APP_STORE = "https://apps.apple.com/us/app/google-authenticator/id388497605";

// User Management
export const INFO_ROLE = `${BLOG_URL}/900001156843-Kelola-Multi-Akun-di-Big-Flip-2-0`;
